import { render, staticRenderFns } from "./SfTable.vue?vue&type=template&id=11b2df3a"
import script from "./SfTable.vue?vue&type=script&lang=js"
export * from "./SfTable.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfTable.vue?vue&type=style&index=0&id=11b2df3a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "9db53144"
  
)

export default component.exports